export enum ZodiacSign {
  AQUARIUS = 'aquarius',
  PISCES = 'pisces',
  ARIES = 'aries',
  TAURUS = 'taurus',
  GEMINI = 'gemini',
  CANCER = 'cancer',
  LEO = 'leo',
  VIRGO = 'virgo',
  LIBRA = 'libra',
  SCORPIO = 'scorpio',
  SAGITTARIUS = 'sagittarius',
  CAPRICORN = 'capricorn',
}

export function getZodiacSign(date: Date): ZodiacSign {
  const day = date.getDate();
  const month = date.getMonth() + 1;

  if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) return ZodiacSign.AQUARIUS;
  if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) return ZodiacSign.PISCES;
  if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return ZodiacSign.ARIES;
  if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return ZodiacSign.TAURUS;
  if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) return ZodiacSign.GEMINI;
  if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) return ZodiacSign.CANCER;
  if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return ZodiacSign.LEO;
  if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return ZodiacSign.VIRGO;
  if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) return ZodiacSign.LIBRA;
  if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) return ZodiacSign.SCORPIO;
  if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) return ZodiacSign.SAGITTARIUS;

  return ZodiacSign.CAPRICORN;
}

export function getNextSign(sign: ZodiacSign): ZodiacSign {
  const signs = Object.values(ZodiacSign) as ZodiacSign[];
  const index = signs.indexOf(sign);

  return signs[(index + 1) % signs.length];
}

export function getPreviousSign(sign: ZodiacSign): ZodiacSign {
  const signs = Object.values(ZodiacSign) as ZodiacSign[];
  const index = signs.indexOf(sign);

  return signs[(index - 1 + signs.length) % signs.length];
}

